import { defineMessages } from 'react-intl';

export default defineMessages({
    caTypeOfIncident: {
        id: 'fnol.ca.views.ca-claim-type.Type of Incident',
        defaultMessage: 'What are the incident circumstances ?'
    },
    typeOfCollisionDropDown:{
        id: 'fnol.ca.views.ca-claim-type.Incident circumstance',
        defaultMessage: 'Incident circumstance'
    },
    blameCodeDropDown: {
        id: 'fnol.ca.views.ca-claim-type.Liability Stance',
        defaultMessage: 'Liability Stance'
    },
    policyLocationDropDown: {
        id: 'fnol.ca.views.ca-claim-type.Policy Location',
        defaultMessage: 'Policy Location'
    },
    policyLocationTooltip: {
        id: 'fnol.pa.views.pa-claim-type.Policy Location.Tooltip',
        defaultMessage: 'Select location associated with the Motor Trade Policy'
    },
    isVehicleRecovered: {
        id: 'fnol.ca.views.ca-collision-loss-details.Has vehicle been recovered',
        defaultMessage: 'Has vehicle been recovered?'
    },
    caCollision: {
        id: 'fnol.ca.views.ca-claim-type.Collision',
        defaultMessage: 'Vehicle Collision'
    },
    caTheft: {
        id: 'fnol.ca.views.ca-claim-type.Theft',
        defaultMessage: 'Theft of vehicle'
    },
    caGlass: {
        id: 'fnol.ca.views.ca-claim-type.Glass',
        defaultMessage: 'Glass'
    },
    caOther: {
        id: 'fnol.ca.views.ca-claim-type.Other',
        defaultMessage: 'Other'
    },
    caNewVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.New Vehicle',
        defaultMessage: 'New Vehicle'
    },
    caWhoDriving: {
        id: 'fnol.ca.directives.vehicle-incident.Who was driving?',
        defaultMessage: 'Who was driving?'
    },
    caChooseDriver: {
        id: 'fnol.ca.directives.vehicle-incident.Choose Driver',
        defaultMessage: 'Choose Driver'
    },
    caVehicleSafe: {
        id: 'fnol.ca.directives.vehicle-incident.Is this vehicle safe to drive?',
        defaultMessage: 'Is this vehicle safe to drive?'
    },
    caResponseYes: {
        id: 'fnol.ca.directives.vehicle-incident.Yes',
        defaultMessage: 'Yes'
    },
    caResponseNo: {
        id: 'fnol.ca.directives.vehicle-incident.No',
        defaultMessage: 'No'
    },
    caDidAirbagDeploy: {
        id: 'fnol.ca.directives.vehicle-incident.Did the airbag deploy?',
        defaultMessage: 'Did the airbag deploy?'
    },
    caEquipmentFailure: {
        id: 'fnol.ca.directives.vehicle-incident.Was there equipment failure?',
        defaultMessage: 'Was there equipment failure?'
    },
    caWasVehicleTowed: {
        id: 'fnol.ca.directives.vehicle-incident.Was the vehicle towed?',
        defaultMessage: 'Was the vehicle towed?'
    },
    caWasRentalNeeded: {
        id: 'fnol.ca.directives.vehicle-incident.Is a rental car needed?',
        defaultMessage: 'Is a rental car needed?'
    },
    caPointOfImpact: {
        id: 'fnol.ca.directives.vehicle-collision.What was the initial point of impact?',
        defaultMessage: 'What was the initial point of impact?'
    },
    caPassengers: {
        id: 'fnol.ca.directives.vehicle-incident.Passengers',
        defaultMessage: 'Passengers'
    },
    caAddPassenger: {
        id: 'fnol.ca.directives.vehicle-incident.Add Passenger',
        defaultMessage: 'Add Passenger'
    },
    caAnotherPerson: {
        id: 'fnol.ca.directives.vehicle-incident.Another person',
        defaultMessage: 'Another person'
    },
    caOtherDriver: {
        id: 'fnol.ca.directives.vehicle-incident.Other Driver',
        defaultMessage: 'Other Driver'
    },
    caNewDriver: {
        id: 'fnol.ca.directives.vehicle-incident.New Driver',
        defaultMessage: 'New Driver'
    },
    caOtherVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Other Vehicle',
        defaultMessage: 'Other Vehicle'
    },
    caNewDriverDetails: {
        id: 'fnol.ca.directives.add-new-driver.New driver details',
        defaultMessage: 'New driver details'
    },
    caFirstName: {
        id: 'fnol.ca.directives.vehicle-incident.First name',
        defaultMessage: 'First name'
    },
    caLastName: {
        id: 'fnol.ca.directives.vehicle-incident.Last name',
        defaultMessage: 'Last name'
    },
    caHomePhone: {
        id: 'fnol.ca.directives.add-new-driver.Home Phone',
        defaultMessage: 'Home Phone'
    },
    caMobilePhone: {
        id: 'fnol.ca.directives.add-new-driver.Mobile Phone',
        defaultMessage: 'Mobile Phone'
    },
    caPhoneNumber: {
        id: 'fnol.ca.directives.vehicle-incident.Phone number',
        defaultMessage: 'Phone number'
    },
    caRemove: {
        id: 'fnol.ca.directives.vehicle-incident.Remove',
        defaultMessage: 'Remove'
    },
    caDelete: {
        id: 'fnol.ca.directives.vehicle-incident.Delete',
        defaultMessage: 'Delete'
    },
    caAddAnotherVehicle: {
        id: 'fnol.ca.views.ca-collision-vehicles.Add Another Vehicle',
        defaultMessage: 'Add Another Vehicle'
    },
    caCollisionDetails: {
        id: 'fnol.wizard.steps.ca.CollisionDetails',
        defaultMessage: 'Details'
    },
    caGlassDetails: {
        id: 'fnol.wizard.steps.ca.GlassDetails',
        defaultMessage: 'Damage'
    },
    caTheftDetails: {
        id: 'fnol.wizard.steps.ca.TheftDetails',
        defaultMessage: 'Details'
    },
    caFleet: {
        id: 'fnol.wizard.steps.ca.Fleet',
        defaultMessage: 'Fleet'
    },
    caWhat: {
        id: 'fnol.wizard.steps.ca.What',
        defaultMessage: 'What'
    },
    caClaimChooseVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Choose Vehicle',
        defaultMessage: 'Choose Vehicle'
    },
    caClaimWhichVehicle: {
        id: 'fnol.ca.directives.vehicle-incident.Which vehicle was damaged?',
        defaultMessage: 'Which vehicle was damaged?'
    },
    caFleetFilter: {
        id: 'fnol.ca.views.ca-fleet.Filter',
        defaultMessage: 'Filter'
    },
    caVehicles: {
        id: 'fnol.wizard.steps.ca.Vehicles',
        defaultMessage: 'Vehicles'
    },
    caVehicleColor: {
        id: 'fnol.ca.directives.add-new-vehicle.Vehicle Color',
        defaultMessage: 'Vehicle Color'
    },
    caVehiclePlate: {
        id: 'fnol.ca.directives.add-new-vehicle.License Plate',
        defaultMessage: 'Vehicle Reg. No.'
    },
    caVehicleMake: {
        id: 'fnol.ca.directives.add-new-vehicle.Make',
        defaultMessage: 'Make'
    },
    caVehicleManufacturer: {
        id: 'fnol.ca.directives.add-new-vehicle.Choose Vehicle Manufacturer',
        defaultMessage: 'Choose Vehicle Manufacturer'
    },
    caVehicleModel: {
        id: 'fnol.ca.directives.add-new-vehicle.Model',
        defaultMessage: 'Model'
    },
    caVehicleState: {
        id: 'fnol.ca.directives.add-new-vehicle.State',
        defaultMessage: 'State'
    },
    caVehicleChooseState: {
        id: 'fnol.ca.directives.add-new-vehicle.Choose Vehicle State',
        defaultMessage: 'Choose Vehicle State'
    },
    caVehicleVIN: {
        id: 'fnol.ca.directives.add-new-vehicle.VIN',
        defaultMessage: 'VIN'
    },
    caVehicleYear: {
        id: 'fnol.ca.directives.add-new-vehicle.Year',
        defaultMessage: 'Year'
    },
    caVehicleChooseYear: {
        id: 'fnol.ca.directives.add-new-vehicle.Choose Vehicle Year',
        defaultMessage: 'Choose Vehicle Year'
    },
    caDeleteVehicleMessage: {
        id: 'fnol.ca.controllers.CACollisionVehicleCtrl.Are you sure you want to delete this third party vehicle?',
        defaultMessage: 'Are you sure you want to delete this third party vehicle?'
    },
    caDeleteVehicleTitle: {
        id: 'fnol.ca.controllers.CACollisionVehicleCtrl.Delete Third Party Vehicle?',
        defaultMessage: 'Delete Third Party Vehicle?'
    },
    CAFleetAffeected: {
        id: 'fnol.ca.views.ca-fleet.Select affected vehicles',
        defaultMessage: 'Select affected vehicle(s)'
    },
    CAFleetSearch: {
        id: 'fnol.ca.views.ca-fleet.Search for License No. or VIN',
        defaultMessage: 'Search for License No. or VIN'
    },
    CAFleetDetails: {
        id: 'fnol.ca.views.ca-fleet.License No.',
        defaultMessage: 'License Number'
    },
    CAFleetNo: {
        id: 'fnol.ca.views.ca-fleet.VIN',
        defaultMessage: 'VIN'
    },
    CAFleetLocation: {
        id: 'fnol.ca.views.ca-fleet.State',
        defaultMessage: 'State'
    },
    CAFleetLocationNo: {
        id: 'fnol.ca.views.ca-fleet.Make',
        defaultMessage: 'Make'
    },
    CAFleetMake: {
        id: 'fnol.ca.views.ca-fleet.Model',
        defaultMessage: 'Model'
    },
    CAFleetYear: {
        id: 'fnol.ca.views.ca-fleet.Year',
        defaultMessage: 'Year'
    },
    CAVehiclesSelected: {
        id: 'fnol.ca.components.summary.Vehicle(s) Selected',
        defaultMessage: 'Vehicle(s) Selected'
    },
    CAAllModels: {
        id: 'fnol.ca.views.ca-fleet.All Models',
        defaultMessage: 'All Models'
    },
    caCreateDraftClaim: {
        id: 'fnol.ca.config.FlowConfig.Creating commercial auto draft claim...',
        defaultMessage: 'Creating commercial auto draft claim...'
    },
    caCreateDraftErrorTitle: {
        id: 'fnol.ca.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    caCreateDraftErrorMessage: {
        id: 'fnol.ca.config.FlowConfig.An error occurred attempting to create your commercial auto claim.',
        defaultMessage: 'An error occurred attempting to create your commercial auto claim.'
    },
    caSaveDraftClaim: {
        id: 'fnol.ca.config.FlowConfig.Saving commercial auto draft claim...',
        defaultMessage: 'Saving commercial auto draft claim...'
    },
    caSaveDraftErrorTitle: {
        id: 'fnol.ca.config.FlowConfig.Error saving claim',
        defaultMessage: 'Error saving claim'
    },
    caSaveDraftErrorMessage: {
        id: 'fnol.ca.config.FlowConfig.An error occurred attempting to save your commercial auto claim.',
        defaultMessage: 'An error occurred attempting to save your commercial auto claim.'
    },
    wizardCARepair: {
        id: 'fnol.wizard.steps.ca.Repair',
        defaultMessage: 'Repair'
    },
    wizardCARepairFacility: {
        id: 'fnol.wizard.steps.ca.Repair Facility',
        defaultMessage: 'Repair Facility'
    },
    recommendedFacilityYouGetca: {
        id: 'fnol.pa.views.ca-service-choice.With a recommended repair facility you get',
        defaultMessage: 'With a recommended repair facility you get:'
    },
    lifetimeGuaranteeca: {
        id: 'fnol.pa.views.ca-service-choice.Lifetime guarantee on all parts and labour',
        defaultMessage: 'Lifetime guarantee on all parts and labour'
    },
    discountOnOtherRepairsca: {
        id: 'fnol.pa.views.ca-service-choice.10% discount on other repairs',
        defaultMessage: '10% discount on other repairs'
    },
    promptRepairServiceca: {
        id: 'fnol.pa.views.ca-service-choice.Prompt, high quality repair service',
        defaultMessage: 'Prompt, high quality repair service'
    },
    preferredRepairChoice: {
        id: 'fnol.ca.views.ca-service-choice.What is the preferred repair method',
        defaultMessage: 'What is the preferred repair method for { licensePlate }'
    },
    repairEstimate: {
        id: 'fnol.ca.views.ca-service-choice.After selecting this option please send us the repair estimate',
        defaultMessage: 'After selecting this option please send us the repair estimate once available. Please send to customerclaims@allianz.co.uk'
    },
    errorMessage: {
        id: 'fnol.ca.views.ca-service-choice.Repair option selection is required',
        defaultMessage: 'Repair option selection is required'
    },
    approvedRepairer: {
        id: 'fnol.ca.views.ca-service-choice.use allianz repair network',
        defaultMessage: 'Use Allianz repair network'
    },
    approvedRepairerSecLabel: {
        id: 'fnol.ca.views.ca-service-choice.Benefits include:',
        defaultMessage: 'We organise repairs through our Allianz repair network. Benefits include:'
    },
    approvedRepairerSecLabelLiOne: {
        id: 'fnol.ca.views.ca-service-choice.Repairs started immediately by one of our accredited repair centres',
        defaultMessage: 'Repairs started as soon as possible, by one of our approved repair centres.'
    },
    approvedRepairerSecLabelLiThree: {
        id: 'fnol.ca.views.ca-service-choice.5 year guarantee on all repairs',
        defaultMessage: 'Lifetime guarantee on all repairs, for as long as you own the vehicle.'
    },
    approvedRepairerSecLabelLiFour: {
        id: 'fnol.ca.views.ca-service-choice.Free courtesy vehicle',
        defaultMessage: 'If your vehicle is under 3.5 tonnes, our repairer will provide you with a Class-A courtesy vehicle, something like a Ford KA or a Nissan Micra, free of charge.'
    },
    approvedRepairerSecLabelLiFive: {
        id: 'fnol.ca.views.ca-service-choice.If you select this option you can track the status of your repairs',
        defaultMessage: 'If you select this option, you can track the status of your repairs on the Allianz Claims Hub.'
    },
    ownRepairer: {
        id: 'fnol.ca.views.ca-service-choice.own repair facility',
        defaultMessage: 'Own repair facility'
    },
    ownRepairerSecLabel: {
        id: 'fnol.ca.views.ca-service-choice.provide details of your facility',
        defaultMessage: 'Provide details of your own repair facility and the estimate from them.'
    },
    approvedRepairerSecLabelLast: {
        id: 'fnol.ca.views.ca-service-choice.After selecting this option our repairer will make contact within the next 2 working hours',
        defaultMessage: 'After selecting this option, our repairer will make contact within the next 24 hours.'
    },
    noRepairer: {
        id: 'fnol.ca.views.ca-service-choice.I don’t need a repair facility',
        defaultMessage: 'I don’t need repair facility'
    },
    noRepairerSecLabel: {
        id: 'fnol.ca.views.ca-service-choice.Don’t worry, you can request service later from a handler.',
        defaultMessage: 'Don’t worry, you can request service later from a handler.'
    },
    ownRepairerFaclityTitle: {
        id: 'fnol.ca.views.ca-new-body-shop.Own Repair Facility details',
        defaultMessage: 'Own repairer facility details'
    },
    ownRepairerFaclityTopNoteOne: {
        id: 'fnol.ca.views.ca-new-body.skip-info-one',
        defaultMessage: 'If you cannot fill the repairer\'s data now, press the '
    },
    ownRepairerFaclityTopNoteTwo: {
        id: 'fnol.ca.views.ca-new-body.skip-info-two',
        defaultMessage: 'Skip '
    },
    ownRepairerFaclityTopNoteThree: {
        id: 'fnol.ca.views.ca-new-body.skip-info-three',
        defaultMessage: 'button at the bottom of the page and fill the data in Claim\'s details tab later.'
    },
    ownRepairerFaclityReason: {
        id: 'fnol.ca.views.ca-new-body-shop.own-repairer.reason',
        defaultMessage: 'Reason for approved repairer decline'
    },
    ownRepairerReasonFleet: {
        id: 'fnol.ca.views.ca-new-body-shop.own-repairer.All of my',
        defaultMessage: 'All of my repairs are arranged through my Fleet provider'
    },
    ownRepairerReasonVehicle: {
        id: 'fnol.ca.views.ca-new-body-shop.own-repairer.My vehicle is',
        defaultMessage: 'My vehicle is new and I want to choose a manufacturer approved repairer'
    },
    ownRepairerReasonPreferred: {
        id: 'fnol.ca.views.ca-new-body-shop.own-repairer.I have a',
        defaultMessage: 'I have a preferred repairer that I know and trust'
    },
    ownRepairerReasonNotaware: {
        id: 'fnol.ca.views.ca-new-body-shop.own-repairer.I wasn’t aware',
        defaultMessage: 'I wasn’t aware of the approved repairer network when I booked my repair'
    },
    ownRepairerReasonBadxp: {
        id: 'fnol.ca.views.ca-new-body-shop.own-repairer.I’ve had a bad',
        defaultMessage: 'I’ve had a bad experience with an Allianz approved network repairer'
    },
    ownRepairerName: {
        id: 'fnol.ca.views.ca-new-body-shop.Name of own repairer',
        defaultMessage: 'Name of own repairer'
    },
    ownRepairerEstimateNoteDescOne: {
        id: 'fnol.ca.views.ca-new-body.info-description-one',
        defaultMessage: 'You can upload an estimate on the '
    },
    ownRepairerEstimateNoteDescTwo: {
        id: 'fnol.ca.views.ca-new-body.info-description-two',
        defaultMessage: 'next page '
    },
    ownRepairerEstimateNoteDescThree: {
        id: 'fnol.ca.views.ca-new-body.info-description-three',
        defaultMessage: '(Supporting Information tab). Alternatively, you can provide this once you\'ve registered the claim, at any time, under '
    },
    ownRepairerEstimateNoteDescFour: {
        id: 'fnol.ca.views.ca-new-body.info-description-four',
        defaultMessage: 'Documents section of the claim or by emailing us at customerclaims@allianz.co.uk .'
    },
    ownRepairerEstimateNoteTitle: {
        id: 'fnol.ca.views.ca-new-body.info-title',
        defaultMessage: 'Upload your estimate on the next page!'
    },
    ownRepairerEngineerNote: {
        id: 'fnol.ca.views.ca-new-body.Notes to the Engineer',
        defaultMessage: 'Notes to the Engineer'
    },
    ownRepairerSkipText: {
        id: 'fnol.ca.views.ca-new-body.Skip',
        defaultMessage: 'Skip'
    },
    postCodeLookupErrorMessage: {
        id: 'platform.inputs.contact-details.Postcode lookup service unavailable, please enter the details manually.',
        defaultMessage: 'Postcode lookup service unavailable, please enter the details manually.'
    },
    postCodeLookupErrorTitle: {
        id: 'platform.inputs.contact-details.Postcode lookup service unavailable',
        defaultMessage: 'Postcode lookup service unavailable, please enter the details manually.'
    },
    convictionListTitle: {
        id: 'fnol.ca.directives.add-new-driver.convictionlist',
        defaultMessage: 'List of conviction codes'
    },
    postCodeLookupErrorConfirmMessage: {
        id: 'platform.inputs.contact-details.ModalProvider.confirmButtonText.Ok',
        defaultMessage: 'Ok'
    },
    ownRepairReasonChangePopupTitle: {
        id: 'fnol.views.ca-own-repair-facility.popupHeader',
        defaultMessage: 'Manufacturer approved repairers in Allianz Network'
    },
    ownRepairReasonChangePopupText: {
        id: 'fnol.views.ca-own-repair-facility.popupCopy',
        defaultMessage: 'Did you know that we can offer a manufacturer approved repairer within our network?'
    },
    ownRepairReasonChangePopupBtn: {
        id: 'fnol.ca.views.ca-own-repair-facility.popupButton',
        defaultMessage: 'Thanks, got it'
    },
    fnolWhatPageNextButton: {
        id: 'fnol.common.views.whatpage.next',
        defaultMessage: 'ch-fnol-what-next-button'
    },
    fnolDetailPageNextButton: {
        id: 'fnol.common.views.detailpage.next',
        defaultMessage: 'ch-fnol-details-next-button'
    },
    fnolVehiclePageNextButton: {
        id: 'fnol.common.views.vehiclepage.next',
        defaultMessage: 'ch-fnol-vehicles-next-button'
    },
    fnolRepairPageNextButton: {
        id: 'fnol.common.views.repairpage.next',
        defaultMessage: 'ch-fnol-repair-next-button'
    }



});
